class CartRemoveButton extends HTMLElement {
	constructor() {
		super()

		this.addEventListener("click", (event) => {
			event.preventDefault()

			const parent =
				event.currentTarget.parentElement.parentElement.parentElement
			const activeIdProduct = parent
				.querySelector(".quantity__input")
				.getAttribute("data-quantity-variant-id")
			if (activeIdProduct === "45577445966126") {
				localStorage.setItem("addTrialProduct", 0)
			}
			const cartItems =
				this.closest("cart-items") || this.closest("cart-drawer-items")
			cartItems.updateQuantity(this.dataset.index, 0)
		})
	}
}

customElements.define("cart-remove-button", CartRemoveButton)

class CartItems extends HTMLElement {
	constructor() {
		super()
		this.lineItemStatusElement =
			document.getElementById("shopping-cart-line-item-status") ||
			document.getElementById("CartDrawer-LineItemStatus")

		const debouncedOnChange = debounce((event) => {
			this.onChange(event)
		}, ON_CHANGE_DEBOUNCE_TIMER)

		this.addEventListener("change", debouncedOnChange.bind(this))

    this.toggleTotalAmountBox();
	}

	cartUpdateUnsubscriber = undefined

	connectedCallback() {
		this.cartUpdateUnsubscriber = subscribe(
			PUB_SUB_EVENTS.cartUpdate,
			(event) => {
				if (event.source === "cart-items") {
					return
				}
				this.onCartUpdate()
			}
		)
	}

	disconnectedCallback() {
		if (this.cartUpdateUnsubscriber) {
			this.cartUpdateUnsubscriber()
		}
	}

	onChange(event) {
		this.updateQuantity(
			event.target.dataset.index,
			event.target.value,
			document.activeElement.getAttribute("name"),
			event.target.dataset.quantityVariantId
		)
	}

	onCartUpdate() {
		if (this.tagName === "CART-DRAWER-ITEMS") {
			fetch(`${routes.cart_url}?section_id=cart-drawer`)
				.then((response) => response.text())
				.then((responseText) => {
					const html = new DOMParser().parseFromString(
						responseText,
						"text/html"
					)
					const selectors = [
						"cart-drawer-items",
						".cart-drawer__footer",
					]
					for (const selector of selectors) {
						const targetElement = document.querySelector(selector)
						const sourceElement = html.querySelector(selector)
						if (targetElement && sourceElement) {
							targetElement.replaceWith(sourceElement)
						}
					}
				})
				.catch((e) => {
					console.error(e)
				})
		} else {
			fetch(`${routes.cart_url}?section_id=main-cart-items`)
				.then((response) => response.text())
				.then((responseText) => {
					const html = new DOMParser().parseFromString(
						responseText,
						"text/html"
					)
					const sourceQty = html.querySelector("cart-items")
					this.innerHTML = sourceQty.innerHTML
				})
				.catch((e) => {
					console.error(e)
				})
		}
	}

	getSectionsToRender() {
		return [
			{
				id: "main-cart-items",
				section: document.getElementById("main-cart-items").dataset.id,
				selector: ".js-contents",
			},
			{
				id: "cart-icon-bubble",
				section: "cart-icon-bubble",
				selector: ".shopify-section",
			},
			{
				id: "cart-live-region-text",
				section: "cart-live-region-text",
				selector: ".shopify-section",
			},
			{
				id: "main-cart-footer",
				section: document.getElementById("main-cart-footer").dataset.id,
				selector: ".js-contents",
			},
		]
	}

	updateQuantity(line, quantity, name, variantId) {
		this.enableLoading(line)

		const body = JSON.stringify({
			line,
			quantity,
			sections: this.getSectionsToRender().map(
				(section) => section.section
			),
			sections_url: window.location.pathname,
		})

		fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
			.then((response) => {
				return response.text()
			})
			.then((state) => {
				const parsedState = JSON.parse(state)
				const quantityElement =
					document.getElementById(`Quantity-${line}`) ||
					document.getElementById(`Drawer-quantity-${line}`)
				const items = document.querySelectorAll(".cart-item")

				if (parsedState.errors) {
					quantityElement.value =
						quantityElement.getAttribute("value")
					this.updateLiveRegions(line, parsedState.errors)
					return
				}

				this.classList.toggle("is-empty", parsedState.item_count === 0)
				const cartDrawerWrapper = document.querySelector("cart-drawer")
				const cartFooter = document.getElementById("main-cart-footer")

				if (cartFooter)
					cartFooter.classList.toggle(
						"is-empty",
						parsedState.item_count === 0
					)
				if (cartDrawerWrapper)
					cartDrawerWrapper.classList.toggle(
						"is-empty",
						parsedState.item_count === 0
					)

				this.getSectionsToRender().forEach((section) => {
					const elementToReplace =
						document
							.getElementById(section.id)
							.querySelector(section.selector) ||
						document.getElementById(section.id)
					elementToReplace.innerHTML = this.getSectionInnerHTML(
						parsedState.sections[section.section],
						section.selector
					)
				})
				const updatedValue = parsedState.items[line - 1]
					? parsedState.items[line - 1].quantity
					: undefined
				let message = ""
				if (
					items.length === parsedState.items.length &&
					updatedValue !== parseInt(quantityElement.value)
				) {
					if (typeof updatedValue === "undefined") {
						message = window.cartStrings.error
					} else {
						message = window.cartStrings.quantityError.replace(
							"[quantity]",
							updatedValue
						)
					}
				}
				this.updateLiveRegions(line, message)
				this.custom()

				const lineItem =
					document.getElementById(`CartItem-${line}`) ||
					document.getElementById(`CartDrawer-Item-${line}`)
				if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
					cartDrawerWrapper
						? trapFocus(
								cartDrawerWrapper,
								lineItem.querySelector(`[name="${name}"]`)
						  )
						: lineItem.querySelector(`[name="${name}"]`).focus()
				} else if (parsedState.item_count === 0 && cartDrawerWrapper) {
					trapFocus(
						cartDrawerWrapper.querySelector(".drawer__inner-empty"),
						cartDrawerWrapper.querySelector("a")
					)
				} else if (
					document.querySelector(".cart-item") &&
					cartDrawerWrapper
				) {
					trapFocus(
						cartDrawerWrapper,
						document.querySelector(".cart-item__name")
					)
				}

				publish(PUB_SUB_EVENTS.cartUpdate, {
					source: "cart-items",
					cartData: parsedState,
					variantId: variantId,
				})
			})
			.catch(() => {
				this.querySelectorAll(".loading-overlay").forEach((overlay) =>
					overlay.classList.add("hidden")
				)
				const errors =
					document.getElementById("cart-errors") ||
					document.getElementById("CartDrawer-CartErrors")
				errors.textContent = window.cartStrings.error
			})
			.finally(() => {
				this.disableLoading(line)
			})
	}

	custom() {
		this.slider()

		const itemCart = document.querySelectorAll(".js-cart-item")

		const idCart = [...itemCart].map((element) => {
			return +element.getAttribute("data-cart-id")
		})

		/* progress bar */

		this.progressBar()
		const progressValues = document.querySelector(".js-progress-values")
		const idGift = +progressValues.getAttribute("data-id")
		const totalAmount = +progressValues.getAttribute("data-total")
		const freeGiftPoint = +progressValues.getAttribute("data-gift")

		itemCart.forEach((element) => {
			const cartId = +element.getAttribute("data-cart-id")
			if (idGift === cartId) {
				element.classList.add("free-gift")
			}
		})
		setTimeout(() => {
			if (totalAmount >= freeGiftPoint) {
				/* add Gift */
				if (!idCart.includes(idGift)) {
					this.addFreeGift(idGift)
				}
			} else {
				this.removeFreeGift(idGift)
			}
		}, 2)
	}

	slider() {
		const swiperNext = document.querySelector(".js-button-next")
		const swiperPrev = document.querySelector(".js-button-prev")
		const swiperWrapper = document.querySelector(".js-swiper-wrapper")
		const cartFrequently = document.querySelector(".js-cart-frequently")
		if (swiperWrapper && swiperWrapper.childElementCount === 0) {
			cartFrequently.classList.add("hidden")
		}
		new Swiper(".js-swiper-frequently", {
			speed: 400,
			loop: true,
			spaceBetween: 20,
			slidesPerView: 1,
			navigation: {
				nextEl: swiperNext,
				prevEl: swiperPrev,
			},
		})
	}

	progressBar() {
		const progressBar = document.querySelector(".js-progress-bar")
    const progressBarTitle = document.querySelector('.js-drawer-progress-title');
		const progressBarFree = document.querySelector(".js-progress-bar-free")
		const progressValues = document.querySelector(".js-progress-values")
		const valuesShipping = document.querySelectorAll(".js-values-shipping")
		const valuesGift = document.querySelectorAll(".js-values-gift")
		const footerShipping = document.querySelector(".js-total_shipping")

		// points
		const totalAmount = +progressValues.getAttribute("data-total")
		const freeShippingPoint = +progressValues.getAttribute("data-shipping")
		const freeGiftPoint = +progressValues.getAttribute("data-gift")

		// %
		let progress = (totalAmount / freeShippingPoint) * 100
		let progressFree = 0

		progress = Math.min(100, Math.max(0, progress))

		if (totalAmount >= freeShippingPoint) {
			progressFree =
				((totalAmount - freeShippingPoint) /
					(freeGiftPoint - freeShippingPoint)) *
				100
			progressFree = Math.min(100, Math.max(0, progressFree))
		}

		progressBar.style.width = progress + "%"
		progressBarFree.style.width = progressFree + "%"

		valuesShipping.forEach((element) => {
			element.classList.remove("active")
		})

		progressBar.classList.remove("active")

		valuesGift.forEach((element) => {
			element.classList.remove("active")
		})

		setTimeout(() => {
			if (totalAmount >= freeShippingPoint) {
				valuesShipping.forEach((element) => {
					element.classList.add("active")
				})
        progressBarTitle.innerHTML = "🎉 Congrats! You've unlocked <strong>FREE SHIPPING!</strong>"
        progressBar.classList.add("active")
        footerShipping?.classList.add("active")
			}
			if (totalAmount >= freeGiftPoint) {
				valuesGift.forEach((element) => {
					element.classList.add("active")
				})
			}
		}, 2)
	}

	addFreeGift(idGift) {
		const formData = {
			items: [
				{
					id: parseInt(idGift),
					quantity: 1,
				},
			],
		}

		fetch(window.Shopify.routes.root + "cart/add.js", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(formData),
		})
			.then((response) => response.json())
			.catch(() => {
				const errors =
					document.getElementById("cart-errors") ||
					document.getElementById("CartDrawer-CartErrors")
				errors.textContent = window.cartStrings.error
			})
			.finally(() => {
				fetch(window.Shopify.routes.root + "?sections=cart-drawer")
					.then((res) => res.json())
					.then((res) => {
						const sectionElements =
							document.querySelector("#CartDrawer")

						sectionElements.innerHTML = this.getSectionInnerHTML(
							res["cart-drawer"],
							"#CartDrawer"
						)
					})
					.finally(() => {
						this.slider()
						this.progressBar()
						const itemCart =
							document.querySelectorAll(".js-cart-item")

						const progressValues = document.querySelector(
							".js-progress-values"
						)
						const idGift = +progressValues.getAttribute("data-id")

						const itemBubble = document.querySelector(
							".cart-count-bubble span:first-child"
						)
						const count = +progressValues.getAttribute("data-count")
						itemBubble.textContent = count

						itemCart.forEach((element) => {
							const cartId = +element.getAttribute("data-cart-id")
							if (idGift === cartId) {
								element.classList.add("free-gift")
							}
						})
					})
			})
	}

	removeFreeGift(idGift) {
		const formData = {
			updates: {
				[parseInt(idGift)]: 0,
			},
		}

		fetch(window.Shopify.routes.root + "cart/update.js", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(formData),
		})
			.then((response) => response.json())
			.catch(() => {
				const errors =
					document.getElementById("cart-errors") ||
					document.getElementById("CartDrawer-CartErrors")
				errors.textContent = window.cartStrings.error
			})
			.finally(() => {
				fetch(window.Shopify.routes.root + "?sections=cart-drawer")
					.then((res) => res.json())
					.then((res) => {
						const sectionElements =
							document.querySelector("#CartDrawer")

						sectionElements.innerHTML = this.getSectionInnerHTML(
							res["cart-drawer"],
							"#CartDrawer"
						)
					})
					.finally(() => {
						const itemCart =
							document.querySelectorAll(".js-cart-item")
						const cartDrawer =
							document.querySelector("cart-drawer.drawer")

						const cartBubble =
							document.querySelector(".cart-count-bubble")

						const progressValues = document.querySelector(
							".js-progress-values"
						)
						const totalAmount =
							+progressValues.getAttribute("data-total")

						this.slider()
						this.progressBar()

						const idGift = +progressValues.getAttribute("data-id")
						itemCart.forEach((element) => {
							const cartId = +element.getAttribute("data-cart-id")
							if (idGift === cartId) {
								element.classList.add("free-gift")
							}
						})
						setTimeout(() => {
							if (document.querySelector("cart-drawer-items").classList.contains('is-empty')) {
								cartDrawer.classList.add("is-empty")
								if (cartBubble) {
									cartBubble.textContent = 0
								}
							} else {
								const itemBubble = document.querySelector(
									".cart-count-bubble span:first-child"
								)
								const count =
									+progressValues.getAttribute("data-count")
								itemBubble.textContent = count
							}
						}, 1)
					})
			})
	}

	updateLiveRegions(line, message) {
		const lineItemError =
			document.getElementById(`Line-item-error-${line}`) ||
			document.getElementById(`CartDrawer-LineItemError-${line}`)
		if (lineItemError)
			lineItemError.querySelector(".cart-item__error-text").innerHTML =
				message

		this.lineItemStatusElement.setAttribute("aria-hidden", true)

		const cartStatus =
			document.getElementById("cart-live-region-text") ||
			document.getElementById("CartDrawer-LiveRegionText")
		cartStatus.setAttribute("aria-hidden", false)

		setTimeout(() => {
			cartStatus.setAttribute("aria-hidden", true)
		}, 1000)
	}

	getSectionInnerHTML(html, selector) {
		return new DOMParser()
			.parseFromString(html, "text/html")
			.querySelector(selector).innerHTML
	}

	enableLoading(line) {
		const mainCartItems =
			document.getElementById("main-cart-items") ||
			document.getElementById("CartDrawer-CartItems")
		mainCartItems.classList.add("cart__items--disabled")

		const cartItemElements = this.querySelectorAll(
			`#CartItem-${line} .loading-overlay`
		)
		const cartDrawerItemElements = this.querySelectorAll(
			`#CartDrawer-Item-${line} .loading-overlay`
		)

		;[...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
			overlay.classList.remove("hidden")
		)

		document.activeElement.blur()
		this.lineItemStatusElement.setAttribute("aria-hidden", false)
	}

	disableLoading(line) {
		const mainCartItems =
			document.getElementById("main-cart-items") ||
			document.getElementById("CartDrawer-CartItems")
		mainCartItems.classList.remove("cart__items--disabled")

		const cartItemElements = this.querySelectorAll(
			`#CartItem-${line} .loading-overlay`
		)
		const cartDrawerItemElements = this.querySelectorAll(
			`#CartDrawer-Item-${line} .loading-overlay`
		)

		cartItemElements.forEach((overlay) => overlay.classList.add("hidden"))
		cartDrawerItemElements.forEach((overlay) =>
			overlay.classList.add("hidden")
		)
	}

  toggleTotalAmountBox() {
    const btnTrigger = document.querySelector('#CartDrawer .js-btn-trigger-total-amount-box');
    const containerTotalAmountBox = document.querySelector('#CartDrawer .js-total-amount-box');

    btnTrigger?.addEventListener("click", () => {
      if (containerTotalAmountBox.classList.contains('isOpen')) {
        containerTotalAmountBox.classList.remove('isOpen')
      } else {
        containerTotalAmountBox.classList.add('isOpen')
      }
    })
  }
}

customElements.define("cart-items", CartItems)

if (!customElements.get("cart-note")) {
	customElements.define(
		"cart-note",
		class CartNote extends HTMLElement {
			constructor() {
				super()

				this.addEventListener(
					"change",
					debounce((event) => {
						const body = JSON.stringify({
							note: event.target.value,
						})
						fetch(`${routes.cart_update_url}`, {
							...fetchConfig(),
							...{ body },
						})
					}, ON_CHANGE_DEBOUNCE_TIMER)
				)
			}
		}
	)
}
